import { ChangeEvent, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { DetailSection } from '../../../../../../../components/generic';

interface Props {
    rosterEmails: string;
    savedRosterEmails: string;
    waitlistEmails: string;
    isUpdating: boolean;
    isWebsitePayment: boolean;
    onRosterEmailChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onUpdate: () => void;
    idPrefix?: string;
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validateEmailList(value: string): string | null {
    if (!value.trim()) return null;
    const emails = value.split(',').map(e => e.trim()).filter(Boolean);
    const invalid = emails.filter(e => !EMAIL_REGEX.test(e));
    if (invalid.length === 0) return null;
    return `Invalid email${invalid.length > 1 ? 's' : ''}: ${invalid.join(', ')}`;
}

export const SessionParentEmailsSection = ({
                                               rosterEmails,
                                               savedRosterEmails,
                                               waitlistEmails,
                                               isUpdating,
                                               isWebsitePayment,
                                               onRosterEmailChange,
                                               onUpdate,
                                               idPrefix = ''
                                           }: Props) => {
    const [validationError, setValidationError] = useState<string | null>(null);

    const isDirty = rosterEmails !== savedRosterEmails;

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setValidationError(validateEmailList(e.target.value));
        onRosterEmailChange(e);
    };

    const handleUpdate = () => {
        const error = validateEmailList(rosterEmails);
        if (error) {
            setValidationError(error);
            return;
        }
        onUpdate();
    };

    return (
        <DetailSection>
            <Form onSubmit={(e) => e.preventDefault()}>
                <Form.Group className="mb-3" controlId={`${idPrefix}rosterEmails`}>
                    <Form.Label>Roster Emails</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        onChange={isWebsitePayment ? undefined : handleChange}
                        value={rosterEmails}
                        readOnly={isWebsitePayment}
                        style={isWebsitePayment ? { backgroundColor: '#f5f6f7' } : undefined}
                        isInvalid={!!validationError}
                    />
                    <Form.Control.Feedback type="invalid">
                        {validationError}
                    </Form.Control.Feedback>
                    {!isWebsitePayment && (
                        <Form.Text className="text-muted">
                            Separate multiple emails with commas
                        </Form.Text>
                    )}
                </Form.Group>
                {!isWebsitePayment && (
                    <Button
                        onClick={handleUpdate}
                        disabled={isUpdating || !!validationError || !isDirty}
                    >
                        {isUpdating ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                Updating...
                            </>
                        ) : (
                            'Update emails'
                        )}
                    </Button>
                )}
            </Form>
            <Form>
                <Form.Label>Waitlist Emails</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    readOnly
                    style={{ backgroundColor: '#f5f6f7' }}
                    value={waitlistEmails}
                />
            </Form>
        </DetailSection>
    );
};